import { ShieldCheck } from "lucide-react";

export const TopBar = ({ hidePrivate = false }) => (
  <header className="evc-topbar" data-testid="evc-topbar">
    <img
      src="/logos/logo-lockup-dark.png"
      alt="Enterprise Value Consulting"
      className="evc-topbar-logo"
      data-testid="evc-logo"
    />
    {!hidePrivate && (
      <div className="evc-topbar-right">
        <span className="evc-lockchip" data-testid="evc-private-badge">
          <ShieldCheck size={13} strokeWidth={2} />
          Private access
        </span>
      </div>
    )}
  </header>
);
